import React, { Component } from 'react';
import WorkFlowTemplate from '../../common/workFlowTemplate'
import SideNav from '../SideNav';

class WorkFlow extends Component {
    render() {
        return (
            <div className="content">
                <SideNav selectKey='siteClose'/>
                <div className="main">
                    <WorkFlowTemplate activeKey='9' />
                </div>  
            </div>
        );
    }
}

export default WorkFlow;


// WEBPACK FOOTER //
// ./src/components/invShutOff/workFlow/index.js